import { ISelectableItem } from '../../';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'horizontal-slider',
    styles: [`
        .slider-container {
            display: block;
            width: 100%;
            overflow-x: auto;
        }
        .horizontal-slider {
            display: block;
            background-color: transparent;            
        }
        .horizontal-slider .item {
            text-align: center;
            padding: 10px 15px;
            display: inline-block;
            transition: 0.2s;
            font-size: 16px;
        }
        .horizontal-slider .item.active {
            transform: scale(1.2);
            color: #FFC107;
        }

    `],
    template: `
        <div class="slider-container">
            <div class="horizontal-slider" [attr.style]="getContainerStyle()">
                <div class="item" *ngFor="let item of items" (click)="activate($event, item)" [class.active]="item.selected">
                    {{item.name}}
                </div>
            </div>
        <div>
    `
})
export class HorizontalSliderComponent implements OnInit {
    @Input() items: ISelectableItem[] = [];
    @Input() itemWidth = 60;

    @Output() itemClicked = new EventEmitter<ISelectableItem>();

    constructor(private _sanitizer: DomSanitizer) { }

    ngOnInit() { }

    getContainerStyle() {
        return this._sanitizer.bypassSecurityTrustStyle(`
            width: ${(this.itemWidth * this.items.length) + (30 * this.items.length) + 300}px;
            margin-left: calc(50% - ${this.itemWidth}px);            
        `);
    }

    activate(e: MouseEvent, item: ISelectableItem) {
        e.preventDefault();
        this.items.forEach(i => i.selected = false);

        item.selected = true;
        this.itemClicked.emit(item);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/horizontal-slider/horizontal-slider.component.ts